export default __webpack_public_path__ + "static/media/contact-us-bg.65e80a2d.jpg";